<template>
  <transition name="fade">
    <div class="pagetop" v-show="scY > 200" @click="toTop">
      <button id="page-top" class="pagetop__btn">TOP</button>
    </div>
  </transition>
</template>


<script>
let timer = null;
const timeout = 100;
const visibleClass = 'is-visible';


export default {
  name: 'Pagetop',

  data: () => {
    return {
      scTimer: 0,
      scY: 0,
    }
  },

  mounted: function() {
      window.addEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function () {
      clearTimeout(timer)
      timer = setTimeout(() => {

        this.scY = window.scrollY || window.pageYOffset

        if (this.scY > 100) {
          if (document.querySelector('.pagetop').className.indexOf(visibleClass) == -1) {
            document.querySelector('.pagetop').classList.add(visibleClass);
          }
        } else {
          if (document.querySelector('.pagetop').className.indexOf(visibleClass) >= 0) {
            document.querySelector('.pagetop').classList.remove(visibleClass);
          }
        }
      }, timeout)
    },

    toTop: function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    },
  }
}
</script>


<style scoped>
</style>